var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"activity-view"},[_c('div',[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#E91E63","size":88,"width":2}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }